import { memoize } from '@infl-ts/util-function';
import { api } from '@infl-ts/util-hub-axios-instance';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import * as Console from 'fp-ts/Console';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { HubApiLensResponse } from './codecs';
import { subscribe } from './lens-notifications';
import { LensStates } from './lens-states';
export var loadLens = function loadLens(memberId, groupId) {
  return api.request({
    method: 'POST',
    url: '/lenses',
    data: {
      impersonated_uuid: memberId,
      group_uuid: groupId
    }
  });
};
export var clearLens = api.request({
  method: 'DELETE',
  url: '/lenses'
});
export var refreshLens = api.request({
  method: 'POST',
  url: '/lenses/refresh'
});
export var activateLens = api.request({
  method: 'POST',
  url: '/lenses/activate'
});
export var cancelLens = api.request({
  method: 'POST',
  url: '/lenses/cancel'
});

var isLensLoadedNotification = function isLensLoadedNotification(attributes) {
  return attributes['action-type'] === 'lens_state_change' && attributes.state === 'loaded';
};

var subscribeToPusher = function subscribeToPusher(lensNotificationHandler) {
  return subscribe(function (_ref) {
    var attributes = _ref.data.attributes;
    return isLensLoadedNotification(attributes) && lensNotificationHandler();
  });
};

export var getCurrentLens = memoize(function (onLensReceived) {
  return pipe(api.request({
    method: 'GET',
    url: '/lenses/current'
  }), TE.chainEitherKW(flow(function (response) {
    return HubApiLensResponse.decode(response.data);
  }, E.mapLeft(makeDecodeError))), TE.map(function (data) {
    var _data$data;

    return ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.attributes) || {
      state: LensStates.Cleared
    };
  }), TE.chainFirstIOK(function (lens) {
    return function () {
      return onLensReceived(lens);
    };
  }));
});
export var subscribeToLens = memoize(function (_ref2) {
  var onLensReceived = _ref2.onLensReceived,
      lensNotificationHandler = _ref2.lensNotificationHandler,
      profileId = _ref2.profileId;
  return pipe(getCurrentLens(onLensReceived), TE.map(function (lens) {
    return lens.state === LensStates.Cleared ? profileId : lens['impersonator-uuid'];
  }), TE.chainW(subscribeToPusher(lensNotificationHandler)), TE.getOrElseW(function (err) {
    return T.fromIO(Console.error('Could not retrieve lens: ' + JSON.stringify(err)));
  }));
});